import { Controller } from "@hotwired/stimulus"

// Toggles between monthly/semestral billing display on subscription plan cards
export default class extends Controller {
  static targets = ["option", "price", "interval", "savings", "subscribeBtn"]

  connect() {
    this.currentInterval = "monthly"
  }

  select(event) {
    const interval = event.currentTarget.dataset.interval
    if (interval === this.currentInterval) return
    this.currentInterval = interval

    // Update option button styles
    this.optionTargets.forEach(btn => {
      if (btn.dataset.interval === interval) {
        btn.classList.remove("bg-white", "text-gray-700")
        btn.classList.add("bg-fitcloud-coral", "text-white", "shadow-sm")
      } else {
        btn.classList.remove("bg-fitcloud-coral", "text-white", "shadow-sm")
        btn.classList.add("bg-white", "text-gray-700")
      }
    })

    // Update prices
    this.priceTargets.forEach(el => {
      el.textContent = el.dataset[interval] || el.dataset.monthly
    })

    // Update interval labels
    this.intervalTargets.forEach(el => {
      el.textContent = el.dataset[interval] || el.dataset.monthly
    })

    // Toggle savings badges
    this.savingsTargets.forEach(el => {
      el.classList.toggle("hidden", interval === "monthly")
    })

    // Update subscribe button billing_interval param
    this.subscribeBtnTargets.forEach(btn => {
      const form = btn.closest("form")
      if (form) {
        let input = form.querySelector('input[name="billing_interval"]')
        if (input) {
          input.value = interval
        }
      }
    })
  }
}
